import React from 'react'

export const Logo = (props) => (
  <img {...props} src='/img/logo.png' alt="Municipalidad de Lautaro" />
);
